// extracted by mini-css-extract-plugin
export default {"generateCostButton":"style_generateCostButton__np7aw"};